__turbopack_context__.v({
  "gwg-section": "gwg-section-module-scss-module__q84J8G__gwg-section",
  "inner-wrapper": "gwg-section-module-scss-module__q84J8G__inner-wrapper",
});
